import React from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import ConsultationsCardView from '@/pages/consultations/components/ConsultationsCardView'
import Pagination from '@/components/ui/pagination/Pagination'
import { ConsultationData } from '@/pages/consultations/components/ConsultationsTable'
import { redirectTo } from '@/utils/consultations'
import { PaginationState, useReactTable, getCoreRowModel } from '@tanstack/react-table'

type ConsultationLightTableMobileProps = {
    data: ConsultationData[]
    page?: number
    totalItems?: number
    defaultPageSize: number
    pageSizeOptions: number[]
    onPaginationChange?: (pagination: PaginationState) => void
    onAcceptConsultation?: (consultationId: string) => void
    onRefuseConsultation?: (consultationId: string) => void
}

export function ConsultationLightTableMobile({
    data,
    page,
    totalItems,
    defaultPageSize,
    pageSizeOptions,
    onPaginationChange,
    onAcceptConsultation,
    onRefuseConsultation
}: ConsultationLightTableMobileProps) {
    const navigate = useNavigate()

    const pagination = {
        pageIndex: page ?? 0,
        pageSize: defaultPageSize
    }

    const table = useReactTable({
        data,
        columns: [], // We don't need columns for the mobile view
        getCoreRowModel: getCoreRowModel(),
        state: {
            pagination
        },
        manualPagination: true,
        pageCount: totalItems ? Math.ceil(totalItems / defaultPageSize) : -1
    })

    const paginatedData = table.getRowModel().rows.map(row => row.original)

    const handleOpenConsultationLive = (consultation: ConsultationData) => {
        navigate(
            redirectTo({
                _id: consultation.id,
                status: consultation.status,
                type: consultation.type,
            })
        )
    }

    return (
        <Box>
            <ConsultationsCardView
                data={paginatedData}
                onAcceptConsultation={onAcceptConsultation ?? (() => { })}
                onRefuseConsultation={onRefuseConsultation ?? (() => { })}
                onOpenConsultationLive={handleOpenConsultationLive}
                onOpenConsultationDetails={(consultation) => {
                    navigate(`/consultations/${consultation.id}`)
                }}
            />
            {data.length > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Pagination
                        page={page ?? 1}
                        totalItems={totalItems ?? data.length}
                        onPageChange={(page, rowsPerPage) =>
                            onPaginationChange?.({ pageIndex: page - 1, pageSize: rowsPerPage })}
                        onItemsPerPageChange={(rowsPerPage) =>
                            onPaginationChange?.({ pageIndex: 0, pageSize: rowsPerPage })}
                        defaultItemsPerPage={defaultPageSize}
                        itemsPerPageOptions={pageSizeOptions}
                    />
                </Box>
            )}
        </Box>
    )
}